export class AuthService {
  constructor(httpClient) {
    this.httpClient = httpClient;
    this.queriesKeys = {
      loginAuth: "loginAuth",
    };
  }

  login(data) {
    return this.httpClient.post("/token/", {
      email: data.email,
      password: data.password
    });
  }
}
